import useTranslation from 'next-translate/useTranslation';

import OnboardingWidget from '../OnboardingWidget';

export function NoFinalContests({
  isFullScreen,
  isWide,
}: {
  isFullScreen?: boolean;
  isWide?: boolean;
}) {
  const { t } = useTranslation('commissioner');

  return (
    <OnboardingWidget
      title={t('onboardingWidget.noFinalContests.title')}
      description={t('onboardingWidget.noFinalContests.description')}
      isFullScreen={isFullScreen}
      isWide={isWide}
    />
  );
}
